import { render, staticRenderFns } from "./MovieLogin.vue?vue&type=template&id=23f68a00"
import script from "./MovieLogin.vue?vue&type=script&lang=js"
export * from "./MovieLogin.vue?vue&type=script&lang=js"
import style0 from "./MovieLogin.vue?vue&type=style&index=0&id=23f68a00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports